import { action } from 'mobx';
import i18next from 'i18next';

import { AppManager } from 'core/index';

import { InitiativeConnManager } from 'apps/initiative/connManager';

export class ConnectOrganisationsManager extends AppManager {
  constructor(parent, init = {}) {
    super(parent, init);
    this.initiativesConn = new InitiativeConnManager(this, {
      sortBy: 'recent',
      initialBatchSize: 18,
      batchSize: 12,
      sortOptions: [
        ['recent', i18next.t('Recent')],
        ['followers', i18next.t('Followers')],
      ],
    });
    this.OrganisationsQuery();
  }

  @action OrganisationsQuery = () => {
    this.initiativesConn.loadMore();
  };
}
